import React from 'react';
import { m } from 'framer-motion';
import { ScrollHintTable } from '../ui/ScrollHintTable';
import { trustStats, trustBadges } from '../../data/trustStats';
export function TrustStats() {
  return <section className="border-y border-white/5 bg-bg-secondary py-8 sm:py-10" data-id="element-265" data-mp="37qiugn60s8wn">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-266" data-mp="32sham00rs5k4">
        <ScrollHintTable minWidth="640px" data-id="element-267" data-mp="32rz6kh7v8n1n">
          <div className="grid grid-cols-4 divide-x divide-white/10" data-id="element-268" data-mp="2yqdnuf8nhejj">
            {trustStats.map((stat, i) => <m.div key={stat.label} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: i * 0.06
          }} className="flex flex-col items-center gap-2 px-3 py-6 text-center" data-id="element-269" data-mp="2tzngiwgnz1m7" data-mpi={i}>
                <stat.icon size={22} className="text-lime" data-id="element-270" data-mp="2f4hawalhd4te" />
                <span className="font-heading text-xl font-bold text-white sm:text-2xl" data-id="element-271" data-mp="2b2ch9bv1886r">{stat.value}</span>
                <span className="text-xs text-muted sm:text-sm" data-id="element-272" data-mp="191oy6arcqlfi">{stat.label}</span>
              </m.div>)}
          </div>
        </ScrollHintTable>

        <p className="mt-6 text-center font-heading text-sm font-semibold uppercase tracking-wider text-success" data-id="element-273" data-mp="z5lw14wi2msk">
          ✓ El Estándar Profesional en el Campo
        </p>

        <div className="mt-6 grid gap-4 sm:grid-cols-3" data-id="element-274" data-mp="141u9mdv1u7xm">
          {trustBadges.map((badge, i) => <m.div key={badge.title} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.08
        }} className="flex items-start gap-3 rounded-2xl border border-white/10 bg-bg-primary p-5" data-id="element-275" data-mp="1wsuboj9tl1mn" data-mpi={i}>
              <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-lime/10" data-id="element-276" data-mp="7ccuz9e39bjs">
                <badge.icon size={20} className="text-lime" data-id="element-277" data-mp="bdet1mw9rhk6" />
              </div>
              <div data-id="element-278" data-mp="2e1n69otih69q">
                <p className="font-heading text-sm font-semibold text-white" data-id="element-279" data-mp="2e49apfl3v5nq">{badge.title}</p>
                <p className="mt-1 text-sm leading-relaxed text-muted" data-id="element-280" data-mp="2956iivq84tx6">{badge.text}</p>
              </div>
            </m.div>)}
        </div>
      </div>
    </section>;
}